import useReexecuteRun, { RerunRequest } from '@/hooks/api/runs/rerun/useReexecuteRun.ts';
import { useCallback } from 'react';

type UseRerunFailedStepsProps = {
  runId: string;
  ignoreCache: boolean;
  targetStepFeedback: string;
  expectedBaseExecutionId?: string | null;
};

const makeExecutionRequest = ({
  ignoreCache,
  targetStepFeedback,
  expectedBaseExecutionId,
}: UseRerunFailedStepsProps): RerunRequest => ({
  config: {
    ignore_cache: ignoreCache,
    run_downstream: true,
    failed_steps_rerun_config: {
      parent_path: '',
      child_index: null,
      include_ask_user: true,
      target_step_feedback: targetStepFeedback.trim(),
    },
  },
  step_feedback: {},
  rerun_context:
    expectedBaseExecutionId === undefined
      ? undefined
      : {
          expected_base_execution_id: expectedBaseExecutionId,
        },
});

const useRerunFailedSteps = () => {
  const { mutate: innerMutate, ...props } = useReexecuteRun();

  const rerunFailedSteps = useCallback(
    (rerunProps: UseRerunFailedStepsProps) => {
      const rerunRequest = makeExecutionRequest(rerunProps);
      return innerMutate({ runId: rerunProps.runId, rerunRequest });
    },
    [innerMutate],
  );

  return { mutate: rerunFailedSteps, ...props };
};

export default useRerunFailedSteps;
